import React, {
  useContext, useEffect, useMemo, useState,
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';

import Loader from '@common/components/loader';
import ToastWrapper from '@common/helpers/toastWrapper';
import './style.scss';
import { POPUPS } from '@common/constants/popups';
import { Logout } from '@app/dev/actions/login';
import KeyboardInput from '@common/components/InputKeyboard';
import { useDispatch } from 'react-redux';

const ChangePasswordForm = ({ user, popupParams }) => {
  const t = useTranslation();
  const [{ openPopup, closePopup }] = useContext(PopupContext);
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    password: '',
    new_password: '',
    confirm_password: '',
  });

  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    let interval;

    if (popupParams?.disable) {
      interval = setTimeout(() => {
        openPopup(popupParams.from, { disable: popupParams.disable, data: popupParams.data });
      }, 5000);
    }

    return () => clearInterval(interval);
  }, [popupParams, openPopup]);

  const submitActive = useMemo(() => (
    form.password && form.new_password && form.confirm_password
  ), [form]);

  const submit = async (e) => {
    e.preventDefault();

    if (!submitActive) return;

    if (form.new_password === form.password) {
      setErrorMessage('Passwords are the same');
      return;
    }

    if (form.new_password !== form.confirm_password) {
      setErrorMessage("Passwords don't match");
      return;
    }

    const data = await swarmRequest(_.omit(form, 'confirm_password'), 'update_user_password');

    if (data.result === 0) {
      ToastWrapper('success', 'Password was successfully changed');
      dispatch(Logout());
      openPopup(POPUPS.RESET_SUCCESS, { title: 'Password was successfully changed' });
      closePopup();
      return;
    }

    if (data.result_text) setErrorMessage(data.result_text);
  };

  const changeField = (name, value) => setForm({ ...form, [name]: value });

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('Change Password')}</h3>
      <div className="popup-main-content">

        <p className="text-center">{t('Please Set the new Password')}</p>

        <div className="input-wrapper">
          <div className="popup-txt">{t('Current password')}</div>
          <div className="input-row">
            <KeyboardInput
              value={form.password}
              type="password"
              name="password"
              onChange={(val) => changeField('password', val)}
              class="popup-inp"
              disableSearchIcon
            />
          </div>
          <div className="popup-txt">{t('New password')}</div>
          <div className="input-row">
            <KeyboardInput
              value={form.new_password}
              type="password"
              name="newPassword"
              onChange={(val) => changeField('new_password', val)}
              class="popup-inp"
              disableSearchIcon
            />
          </div>
          <div className="popup-txt">{t('Confirm password')}</div>
          <div className="input-row">
            <KeyboardInput
              value={form.confirm_password}
              type="password"
              name="confirmPassword"
              onChange={(val) => changeField('confirm_password', val)}
              class="popup-inp"
              disableSearchIcon
            />
          </div>
          <div />

          {errorMessage && <div className="error-message">{t(errorMessage)}</div>}

        </div>
      </div>

      <div className="popup-actions">
        <button
          type="button"
          onClick={() => {
            closePopup();
          }}
          className="popup-cancel-button"
        >
          {t('Cancel')}
        </button>
        <button
          onClick={submit}
          type="button"
          className="popup-confirm-button"
          disabled={!submitActive}
        >
          {t('Change')}
        </button>
      </div>
      {user?.loginInProgress && <Loader />}
    </div>
  );
};

ChangePasswordForm.propTypes = {
  popupParams: PropTypes.object,
  user: PropTypes.object,
};

export default ChangePasswordForm;
